var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardAmexColored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 15,
    viewBox: "0 0 22 15",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(0 .000013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 .00003897h22v15.00000003h-22z",
    fill: "#016fd0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.43375 12.62625v-5.375l9.56625.00875v1.485l-1.10625 1.18125 1.10625 1.1925v1.51625h-1.765l-.93875-1.035-.93125 1.03875z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.0725 12.0375v-4.19375h3.55625v.965h-2.405v.65625h2.3475v.95h-2.3475v.64375h2.405v.97875z",
    fill: "#016fd0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.61125 12.0375 1.9675-2.1-1.9675-2.09375h1.5225l1.2025 1.32875 1.20625-1.32875h1.4575v.0325l-1.92625 2.06125 1.92625 2.04v.06h-1.4725l-1.22375-1.3425-1.21125 1.3425z",
    fill: "#016fd0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.88 2.48125h2.30625l.81 1.83875v-1.83875h2.84625l.49125 1.3775.4925-1.3775h2.17375v5.375h-11.48875z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#016fd0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.3125 3.0625-1.8625 4.1875h1.3l.35-.8375h1.9l.35.8375h1.3125l-1.8625-4.1875h-1.475zm.1625 2.4125.5625-1.3375.55 1.3375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.62625 7.255v-4.19125l1.795.0075.9225 2.575.93-2.5825h1.72625v4.19125l-1.11125.01v-2.87875l-1.04875 2.86875h-1.01375l-1.07125-2.87875v2.87875z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardAmexColored);
export default __webpack_public_path__ + "static/media/cardAmexColored.8b4525267bcc67f64e14995bcb811981.svg";
export { ForwardRef as ReactComponent };